import jQuery from '@node/jquery';
window.$ = window.jQuery = jQuery;
